import PageHeader from "@/components/PageHeader";

interface PlaceholderProps {
  title: string;
  phase: string;
  description: string;
}

export default function Placeholder({ title, phase, description }: PlaceholderProps) {
  return (
    <>
      <PageHeader
        title={title}
        subtitle={phase ? <span className="text-brand-orange">{phase}</span> : null}
      />
      <div className="px-8 py-10">
        <div className="max-w-2xl rounded-md border border-surface-border bg-surface px-6 py-6 text-sm text-slate-300">
          <div className="font-medium text-slate-100">Coming soon</div>
          <p className="mt-2 leading-relaxed text-brand-dim">{description}</p>
          <p className="mt-4 leading-relaxed text-brand-dim">
            Tracked in{" "}
            <code className="rounded bg-surface-sunken px-1.5 py-0.5 text-xs">
              docs/FLEET_BACKEND_IMPLEMENTATION_PLAN.md
            </code>{" "}
            §6.
          </p>
        </div>
      </div>
    </>
  );
}
